// extracted by mini-css-extract-plugin
module.exports = {"description_container":"Description_description_container__14rUL","modal_heading":"Description_modal_heading__3vfA1","desc":"Description_desc__2IKRc"};